/* eslint camelcase: 0 */
import { Area, AreaSeed } from '@/infrastructure/network/Legacy/schema'
import { IAreaProps, EmptyAreaPropsFactory } from '@/entities/Legacy/Area'

export const toAreaProps = (props: Area): IAreaProps => {
  if (!props) {
    return EmptyAreaPropsFactory()
  }

  const { id, hospital_id, name, beacon_x, beacon_y, area_x, area_y, area_width, area_height, is_fixed } = props
  return {
    id,
    hospitalId: hospital_id,
    name,
    beaconX: beacon_x,
    beaconY: beacon_y,
    areaX: area_x,
    areaY: area_y,
    areaWidth: area_width,
    areaHeight: area_height,
    fixed: is_fixed
  }
}

export const toAreaSeed = (props: IAreaProps): AreaSeed => {
  const { id, name } = props
  return {
    id,
    name,
    order: 0
  }
}
